import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="relative overflow-hidden pt-40 pb-16 lg:pt-44 lg:pb-20">
      <div className="absolute inset-0 bg-brand-navy2/50" />
      <div className="absolute inset-0 grid-overlay opacity-40" />
      <div className="absolute -top-32 right-10 h-[360px] w-[360px] rounded-full bg-brand-lime/10 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-6">
        <div className="flex items-center gap-2 text-xs text-slate-400">
          <Link to="/" className="hover:text-brand-lime transition-colors">Home</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-brand-lime">{eyebrow}</span>
        </div>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold text-white max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-lg text-slate-400">{subtitle}</p>}
      </div>
    </section>
  );
}
